.product-awards-img-lg {
  --se-carousel-item-width: 75%;
}

@media screen and (min-width: 720px) and (max-width: 980px) {
  .product-awards-img-lg {
    --se-carousel-item-width: 75%;
  }
}

@media screen and (max-width: 719px) {
  .product-awards-img-lg {
    --se-carousel-item-width: 100%;
  }
}

.product-awards-img-md {
  --se-carousel-item-width: calc(
    (100%) / 2
  );
}

@media screen and (min-width: 720px) and (max-width: 980px) {
  .product-awards-img-md {
    --se-carousel-item-width: calc(
      (100%) / 2
    );
  }
}

@media screen and (max-width: 719px) {
  .product-awards-img-md {
    --se-carousel-item-width: 100%;
  }
}

.product-awards-img-sm {
  --se-carousel-item-width: calc(
    (100%) / 3
  );
}

@media screen and (min-width: 720px) and (max-width: 980px) {
  .product-awards-img-sm {
    --se-carousel-item-width: calc(
      (100%) / 3
    );
  }
}

@media screen and (max-width: 719px) {
  .product-awards-img-sm {
    --se-carousel-item-width: 100%;
  }
}